import React, { useState } from 'react';
import { RegisterItemList } from './RegisterItemList';
import { RaiseArtefactModal } from '../components/RaiseArtefactModal';
import { useSearchParams } from 'react-router-dom';

const riskLevelTone = (value: string): string => {
  const v = value.toLowerCase();
  if (v.includes('critical')) return 'danger';
  if (v.includes('high')) return 'danger';
  if (v.includes('medium') || v.includes('moderate')) return 'warning';
  if (v.includes('low')) return 'success';
  if (v.includes('minimal') || v.includes('very low')) return 'neutral';
  return 'neutral';
};

const RiskLevelBadge: React.FC<{ value: string }> = ({ value }) =>
  value
    ? <span className={`np-chip np-tone-${riskLevelTone(value)}`}>{value}</span>
    : <span style={{ color: 'var(--bs-secondary-color)' }}>—</span>;

// Risk level values are formatted like "Critical (25)" - sort by the actual
// 1-25 score, not alphabetically (which would put "Critical" before "Low").
// Unscored rows sort to the bottom in ascending order.
const riskLevelSortValue = (value: string): number => {
  const match = value.match(/\((\d+)\)/);
  return match ? parseInt(match[1], 10) : -1;
};

export const RiskList: React.FC = () => {
  const [searchParams] = useSearchParams();
  const registerId = searchParams.get('registerId') || '';
  const [raiseRisk, setRaiseRisk] = useState<{ id: string; title: string } | null>(null);

  return (
    <>
      <RegisterItemList
        title="Risks"
        iconClass="ri-alert-line"
        listPath="/risks"
        detailPathPrefix="/risks"
        registersPath="/registers"
        idField="riskId"
        titleField="risk_title"
        priorityField="priority"
        statusField="status"
        registerQueryParam="registerId"
        extraColumns={[
          {
            header: 'Inherent Risk',
            width: '140px',
            render: (item) => <RiskLevelBadge value={item.fields?.inherent_risk ?? item.inherent_risk ?? ''} />,
            sortValue: (item) => riskLevelSortValue(item.fields?.inherent_risk ?? item.inherent_risk ?? ''),
          },
          {
            header: 'Residual Risk',
            width: '140px',
            render: (item) => <RiskLevelBadge value={item.fields?.residual_risk ?? item.residual_risk ?? ''} />,
            sortValue: (item) => riskLevelSortValue(item.fields?.residual_risk ?? item.residual_risk ?? ''),
          },
        ]}
        rowActions={(id, title) => (
          <button
            type="button"
            className="np-icon-btn np-icon-btn-success"
            title="Raise Issue / Incident"
            onClick={() => setRaiseRisk({ id, title })}
          >
            <i className="ri-add-circle-line"></i>
          </button>
        )}
      />
      {raiseRisk && (
        <RaiseArtefactModal
          riskId={raiseRisk.id}
          riskTitle={raiseRisk.title}
          riskRegister={registerId}
          allowedTypes={['issue', 'incident']}
          onClose={() => setRaiseRisk(null)}
        />
      )}
    </>
  );
};
